module.exports = __webpack_public_path__ + "img/DW365-048.dd59e4b9.jpg";